/***
 * 姓名 :D
 * 创建时间:2019-3-8
 * 描述：websocket 消息队列服务
 * 更新记录：
 */
import { Injectable } from "@angular/core";
import { Subject, Observable, Observer } from "rxjs";
@Injectable()
export class LoginWebSocketService {
  public ws: any;
  constructor() {}

  /**
   * 消息队列公共方法
   * @param uri 请求的消息队列参数
   */
  public create(uri: string): Subject<MessageEvent> {
    this.ws = new WebSocket(uri);
    this.ws.onopen = () => {};

    let observable = Observable.create((obs: Observer<MessageEvent>) => {
      this.ws.onmessage = obs.next.bind(obs);
      this.ws.onerror = obs.error.bind(obs);
      this.ws.onclose = obs.complete.bind(obs);
      return this.ws.close.bind(this.ws);
    });
    let observer = {
      next: (data: any) => {
        if (this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(data);
        }
      },
    };
    return Subject.create(observer, observable);
  }

  public close() {
    this.ws && this.ws.onclose();
  }

  public open() {
    this.ws && this.ws.onopen();
  }
}
